<script setup lang="ts">
import Modal from '@/components/ui/Modal.vue'

defineProps<{ open: boolean }>()
defineEmits<{ close: [] }>()
</script>

<template>
  <Modal :open="open" title="Что такое смены сервера?" max-width="lg" @close="$emit('close')">
    <div class="space-y-4 text-sm leading-relaxed text-[#1f2937]">
      <p>
        Смена сервера - если скорость упала или соединение не работает, вы можете перенести ключи на другой сервер
        без повторной покупки подписки.
      </p>

      <div>
        <p class="mb-2 font-semibold">Как начисляются смены</p>
        <ul class="list-disc space-y-1.5 pl-5">
          <li>
            Доступное количество зависит от <strong>оставшегося срока</strong> ключа: 1 смена за каждые
            <strong>7 полных дней</strong> срока ключа, максимум 4 смены на ключ. Раз в месяц, в день активации ключа, лимит пополняется до 4.
          </li>
          <li>
            Примеры: <strong>7 дней</strong> → 1 смена, <strong>30 дней</strong> → 4 смены.
          </li>
          <li>
            Отсчёт начинается с момента <strong>активации ключа</strong> в личном кабинете.
          </li>
        </ul>
      </div>

      <div>
        <p class="mb-2 font-semibold">Правила использования</p>
        <ul class="list-disc space-y-1.5 pl-5">
          <li>
            Смена списывается только после <strong>подтверждения</strong> - пока смена в процессе, баланс не уменьшается.
          </li>
          <li>
            После успешной смены этот ключ нельзя менять <strong>12 часов</strong>. После отмены пауза <strong>5 минут</strong> на первые три раза за сутки, дальше каждая следующая отмена добавляет 5 минут. Через сутки счётчик отмен сбрасывается. Другие ваши ключи не блокируются.
          </li>
          <li>
            При продлении ключа баланс смен <strong>добирается</strong> по новому сроку до максимума 4 на этот ключ.
          </li>
        </ul>
      </div>

      <div>
        <p class="mb-2 font-semibold">Рекомендация</p>
        <p>
          Сначала обратитесь в поддержку - часто проблему со скоростью или подключением можно решить
          без смены сервера.
        </p>
      </div>
    </div>

    <template #footer>
      <button type="button" class="btn btn-primary" @click="$emit('close')">
        Закрыть
      </button>
    </template>
  </Modal>
</template>
